import * as React from 'react';
import {Dispatch} from "react";

type personalFormDataProps = {
    translations: any,
    nameSurNameError: boolean,
    nameSurname: string,
    emailError: boolean,
    email: string,
    phoneNumberError: boolean,
    phoneNumber: string,
    message: string,
    setNameSurname: Dispatch<any>,
    setEmail: Dispatch<any>,
    setPhoneNumber: Dispatch<any>,
    setMessage: Dispatch<any>
};

export const PersonFormData = ({
                                   translations,
                                   nameSurNameError,
                                   nameSurname,
                                   emailError,
                                   email,
                                   phoneNumberError,
                                   phoneNumber,
                                   message,
                                   setNameSurname,
                                   setEmail,
                                   setPhoneNumber,
                                   setMessage
                               }: personalFormDataProps) => {
    return (
        <>
            <div className="col-md-12">
                <input
                    style={nameSurNameError ? {borderColor: 'red'} : {}}
                    id="name-surname"
                    value={nameSurname}
                    onChange={e => setNameSurname(e.target.value)}
                    className="form-control"
                    placeholder={translations.name_surname}
                />
            </div>
            <div className="col-md-6">
                <input
                    style={emailError ? {borderColor: 'red'} : {}}
                    id="email-address"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="form-control"
                    placeholder={translations.email}
                />
            </div>
            <div className="col-md-6">
                <input
                    style={phoneNumberError ? {borderColor: 'red'} : {}}
                    id="phone-number"
                    value={phoneNumber}
                    onChange={e => setPhoneNumber(e.target.value)}
                    className="form-control"
                    placeholder={translations.phone_number}
                    onFocus={e => e.target.placeholder = '+370'}
                    onBlur={e => e.target.placeholder = translations.phone_number}
                />
            </div>
            <div className="col-md-12">
                    <textarea id="individual-message" className="form-control" value={message}
                              onChange={e => setMessage(e.target.value)}
                              placeholder={translations.individual_message}/>
            </div>
        </>
    );
}
